import { useAppState } from 'contexts/AppContext';
import type { Patient } from 'fhir/r4';
import { List } from 'semantic-ui-react';

import * as FHIRUtils from '../../../utils/FHIRUtils';
import { formatPhoneNumber } from '../../../utils/utils';

/** `card.tsx` passes its own `fhirPatient` straight through as the popup content. */
interface MemberQuickInfoProps {
  patient: Patient;
}

function MemberQuickInfo(props: MemberQuickInfoProps) {
  const { appState } = useAppState();

  const { payers } = appState;

  const fhirPatient: Patient = props.patient;
  const flatPatient = FHIRUtils.parseFHIRPatient(fhirPatient);

  const getOrgDisplayName = (orgId: string) => {
    const orgDisplay = payers.find((obj) => obj.key === orgId)?.text;
    return orgDisplay;
  };
  return (
    <div>
      <List>
        <List.Item>
          <List.Icon name="marker" color="orange" />
          <List.Content>{flatPatient.address}</List.Content>
        </List.Item>
        <List.Item>
          <List.Icon name="mail" color="blue" />
          <List.Content>{flatPatient.email}</List.Content>
        </List.Item>
        <List.Item>
          <List.Content>
            {((flatPatient.mobilePhone[0] && flatPatient.mobilePhone[0] !== '') ||
              (flatPatient.homePhone[0] && flatPatient.homePhone[0] !== '')) && (
              <List.Icon name="phone" color="purple" />
            )}
            {flatPatient.mobilePhone[0] && flatPatient.mobilePhone[0] !== '' && (
              <>
                {formatPhoneNumber(flatPatient.mobilePhone)}
                {flatPatient.homePhone[0] && flatPatient.homePhone[0] !== '' && <> &nbsp; | &nbsp; </>}
              </>
            )}

            {flatPatient.homePhone[0] && flatPatient.homePhone[0] !== '' && (
              <>{formatPhoneNumber(flatPatient.homePhone)}</>
            )}
            <>&nbsp; </>
            <List.Icon name="briefcase" color="green" />
            <>{getOrgDisplayName(flatPatient.org)}</>
          </List.Content>
        </List.Item>
        {/* <List.Item>
                    <List.Icon name="user" color="teal" />
                    <List.Content>
                        {`PW MemberId: ${flatPatient.id}`}
                    </List.Content>
                </List.Item> */}
        {/* <List.Item>
                        <List.Icon name="user" color="teal" />
                        <List.Content>
                            Last Upadted:{moment(flatPatient.lastUpdated).fromNow()}
                        </List.Content>
                    </List.Item> */}
      </List>
    </div>
  );
}

export default MemberQuickInfo;
